export const GET_HARDWARE_ITEMS = 'GET_HARDWARE_ITEMS';
export const GET_PURCHASED_HARDWARE = 'GET_PURCHASED_HARDWARE';
export const GET_HARDWARE_REQUEST = 'GET_HARDWARE_REQUEST';
export const GET_HARDWARE_PROPOSAL = 'GET_HARDWARE_PROPOSAL';
export const GET_HARDWARE_MOVMENT = 'GET_HARDWARE_MOVMENT';
export const GET_HARDWARE_COLLECTOR = 'GET_HARDWARE_COLLECTOR';
export const GET_HARDWARE_INVENTORY = 'GET_HARDWARE_INVENTORY';
export const GET_HARDWARE_DISTRIBUTERS = 'GET_HARDWARE_DISTRIBUTERS';
